import { z } from 'zod'

export const ADMIN = 'admin'
export const CUSTOMER = 'customer'

export const role = z.enum([ADMIN, CUSTOMER])

export const roles = Object.values(role.enum)

export type Role = z.infer<typeof role>
